export const blockIconsTransportationLocalShippingNew = (
	<span className='material-symbols-outlined'>local_shipping</span>
);
